import { useCallback } from 'react';
import { setRecentlyViewed } from 'store/search/search-actions';
import { setHighlightedSpotId, setMobileMapViewInteractionTrigger, setPreviewedSpotId, } from 'store/spots/spots-actions';
import { useDispatch, useSelector } from 'react-redux';
export const useOnSpot = ({ onSpotDetailCallback, }) => {
    const dispatch = useDispatch();
    const isAdmin = useSelector((state) => state.user.data.isAdmin);
    const onSpotDetail = useCallback(({ spotId, markerType }) => {
        if (!isAdmin && markerType === 'disabled') {
            return;
        }
        onSpotDetailCallback(spotId);
    }, [isAdmin, onSpotDetailCallback]);
    const onSpotHighlighted = useCallback(({ spotId }) => {
        dispatch(setHighlightedSpotId({ spotId }));
    }, [dispatch]);
    const onSpotPreviewed = useCallback(({ spotId }) => {
        if (spotId) {
            dispatch(setRecentlyViewed(spotId));
        }
        dispatch(setMobileMapViewInteractionTrigger({ trigger: 'click' }));
        dispatch(setPreviewedSpotId({ spotId }));
    }, [dispatch]);
    return {
        onSpotDetail,
        onSpotHighlighted,
        onSpotPreviewed,
    };
};
